import * as go from 'gojs';

export const getSubgraphs = (nodes: go.Set<go.Node>) => {
  const graphs: Array<Set<go.Node>> = [];

  nodes.each((node) => {
    if (graphs.some((x) => x.has(node))) {
      return;
    }
    const graph = traverseGraph(node);
    graphs.push(graph);
  });

  return graphs;
};

const traverseGraph = (node: go.Node) => {
  const graph = new Set<go.Node>();
  const queue = [node];
  while (queue.length > 0) {
    const currentNode = queue.pop();
    if (currentNode && !graph.has(currentNode)) {
      graph.add(currentNode);
      currentNode.findLinksConnected().each((link) => {
        // add nodes connected to current node
        if (link.toNode && link.toNode !== currentNode) {
          queue.push(link.toNode);
        } else if (link.fromNode && link.fromNode !== currentNode) {
          queue.push(link.fromNode);
        }
        // find edge properties nodes and add them too
        link.data.labelKeys.forEach((labelKey: string) => {
          const { diagram } = link;
          if (diagram) {
            diagram
              .findNodeForKey(labelKey)
              ?.findLinksOutOf()
              .each((link) => {
                if (link.toNode) {
                  graph.add(link.toNode);
                }
              });
          }
        });
      });
    }
  }

  return graph;
};
